import { orderStatus } from "./index";

export const validPog = (pog = {}) => {
  return (
    pog?.ReleaseStatus !== orderStatus.released && !pog?.AllItemsFromFillIn
  );
};
